import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../../auth";
import { getBranch } from "../../features/gyms/helper/api";

const MobileOnlyGate = ({ children }) => {
  const { user, token } = isAuthenticated();
  const [isBlocked, setIsBlocked] = useState(false);

  const checkBlock = async () => {
    try {
      const isDesktop = window.innerWidth >= 768; //chosen rule
      if (!isDesktop) { setIsBlocked(false); return; }
      if (user.role == 0) { setIsBlocked(false); return; } // anti-lockout: superadmin always allowed
      if (window.location.pathname.includes("configurations")) { 
        setIsBlocked(false);
        return;
     }

      const branchId = localStorage.getItem("branchId");
      if (!branchId) { setIsBlocked(false); return; }
      const res = await getBranch(user._id, token, branchId);
      const perms = res?.branchconfig?.[0]?.permissions || [];
      setIsBlocked(perms.includes("only_mobile"));
    } catch(e){ setIsBlocked(false); }
  };

  useEffect(()=>{
    checkBlock();
    window.addEventListener("resize", checkBlock);
    window.addEventListener("branchIdChanged", checkBlock);
    window.addEventListener("storage", checkBlock);
    return ()=>{
      window.removeEventListener("resize", checkBlock);
      window.removeEventListener("branchIdChanged", checkBlock);
      window.removeEventListener("storage", checkBlock);
    };
  },[]);

  if (!isBlocked) return <>{children}</>;
  return (
    <div style={{height:"100vh", width:"100vw", position:"fixed", top:0, left:0, zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", background:"#DEF3FF", padding:"24px", textAlign:"center"}}>
      <div style={{maxWidth:"420px", background:"#fff", borderRadius:"16px", padding:"32px"}}>
        <h2 style={{color:"#0a3d62"}}>Unlock the Full Desktop Experience</h2>
        <p>Your current plan is optimized for <b>Mobile access</b>. Please <b>Upgrade</b> for full desktop access to schedules, reports, and check-in logs</p>
        <p style={{fontSize:"12px", color:"#666"}}>Contact our support team to upgrade.</p>
      </div>
    </div>
  );
};
export default MobileOnlyGate;